export default "__VITE_ASSET__BIQSGRZ4__"